export default {
    namespaced: true,
    state: {
        status: "hide"
    },
    mutations: {
        show(state) {
            state.status = "show";
        },
        hide(state) {
            state.status = "hide";
        },
    },
    actions: {
        show({commit}) {
            commit("show");
        },
        hide({commit}) {
            commit("hide");
        }
    },
    getters: {
        showBanner( state ) {
            return state.status == 'show';
        },
    },
    modules: {}
}
